import { cloneDeep } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Table } from "semantic-ui-react";

import ActionDropdownMenu from "../actionDropdownMenu/ActionDropdownMenu.jsx";
import withConfirmationModal from "../modals/withConfirmationModal.js";
import LinkWithReset from "../utils/LinkWithReset.jsx";

import { AT_TYPES } from "../../constants/entity.js";
import { ROUTES } from "../../constants/routing.js";
import { OPERATIONS } from "../../constants/operations.js";

import { operationActionByType } from "../../state/reducers/operations/operationActions.js";
import { getEntityAction } from "../../state/actions/entityActions.js";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class EntityUserMembershipList extends PureComponent {
  static propTypes = {
    entityId: PropTypes.string.isRequired,
    memberships: PropTypes.array,
    location: PropTypes.object,
    showHeader: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,

    openModal: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,

    operationActionByType: PropTypes.func.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false,
    showHeader: false
  };

  constructor(props) {
    super(props);

    this.state = {
      activeMember: undefined
    };
  }

  // -- HANDLERS -- //

  handleDelete = activeMember => {
    const { memberships, openModal } = this.props;

    const membership = cloneDeep(
      memberships.find(item => item["@id"] === activeMember)
    );

    this.setState({ activeMember: activeMember }, () => {
      openModal(
        this.doDelete,
        `users.user_panel.modals.delete_modal`,
        undefined,
        membership
      );
    });
  };

  doDelete = () => {
    const { memberships, location, entityId, operationActionByType } =
      this.props;
    const { activeMember } = this.state;

    const membership = memberships.find(item => item["@id"] === activeMember);

    // This should be refactored out into the parent but I'm out of time :/
    const successActions = [
      getEntityAction(location.pathname, {
        showErrorModal: false
      }),
      getEntityAction(entityId, {
        showErrorModal: false
      })
    ];

    operationActionByType(
      membership["@type"],
      membership,
      OPERATIONS.DELETE,
      undefined,
      {
        success: successActions
      }
    );
  };

  // -- RENDER -- //

  getViewPath = item => {
    let viewPath = undefined;

    if (item["@type"] === AT_TYPES.WORKSTATION) {
      viewPath = `${ROUTES.RESOURCES}${item["@id"]}`;
    }

    return viewPath;
  };

  renderItemName = item => {
    const viewPath = this.getViewPath(item);

    if (item["@type"] === AT_TYPES.WORKSTATION && viewPath) {
      return (
        <LinkWithReset to={viewPath} className="table-link">
          {item.name}
        </LinkWithReset>
      );
    }

    return item.name;
  };

  renderMembershipRows = () => {
    const { memberships, copy } = this.props;

    return memberships.map(item => {
      if (typeof item !== "object") return null;

      return (
        <Table.Row key={item["@id"]}>
          <Table.Cell>{this.renderItemName(item)}</Table.Cell>
          <Table.Cell collapsing>
            <ActionDropdownMenu
              data={item}
              viewPath={this.getViewPath(item)}
              onDelete={this.handleDelete}
              copy={copy("basic_resource_actions")}
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  };

  render() {
    const { memberships, showHeader, copyKey, copy } = this.props;

    // bail early if base permissions are not met
    if (!memberships) return null;

    if (memberships.length < 1) {
      return <p>{copy(`${copyKey}.no_access_description`)}</p>;
    }

    return (
      <Table disabled celled basic striped unstackable>
        {showHeader && (
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>{copy(`${copyKey}.name`)}</Table.HeaderCell>
              <Table.HeaderCell collapsing />
            </Table.Row>
          </Table.Header>
        )}
        <Table.Body>{this.renderMembershipRows()}</Table.Body>
      </Table>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

const mapDispatchToProps = dispatch => ({
  operationActionByType: (...args) => dispatch(operationActionByType(...args))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withConfirmationModal(EntityUserMembershipList));
